import { levelToColorMapping, type ComponentLevel } from '~/styles/constants';
import type { Theme } from '~/theme';

type State = 'checked' | 'unchecked' | 'disabled' | 'circle';

/**
 * Returns background colors for certain states and elements in ToggleCheckbox
 *
 * @param {Theme} theme
 * @param {State} state
 */
const getBackgroundColor = (
  theme: Theme,
  appearance: ComponentLevel,
  state: State,
) => {
  switch (state) {
    case 'checked':
      return theme.color(levelToColorMapping[appearance], 'light');
    case 'unchecked':
      return theme.color('tertiary', 'dark');
    case 'disabled':
      return theme.color('tertiary', 'light');
    default:
      return theme.color('tertiary');
  }
};

export default getBackgroundColor;
